import {Column} from 'react-table'
import {PropertyRegistriesActionsCell} from './PropertyRegistriesActionsCell'
import {PropertyRegistriesCustomHeader} from './PropertyRegistriesCustomHeader'
import {PropertyRegistries} from '../../core/_models'
import {PropertyRegistriesDescription} from './PropertyRegistriesDescription'
import {PropertyRegistriesOrder} from './PropertyRegistriesOrder'
import {PropertyRegistriesStatus} from './PropertyRegistriesStatus'

const PropertyRegistriesColumns: ReadonlyArray<Column<PropertyRegistries>> = [
  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <PropertyRegistriesCustomHeader
        tableProps={props}
        title='PROPERTY_REGISTRIES.ORDER'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'order',
    Cell: ({...props}) => (
      <PropertyRegistriesOrder PropertyRegistries={props.data[props.row.index]} />
    ),
  },

  {
    Header: (props) => (
      <PropertyRegistriesCustomHeader
        tableProps={props}
        title='COMMON.DESCRIPTION'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'description',
    Cell: ({...props}) => (
      <PropertyRegistriesDescription PropertyRegistries={props.data[props.row.index]} />
    ),
  },

  //HEADER COLUMN -  Status ***
  {
    Header: (props) => (
      <PropertyRegistriesCustomHeader
        tableProps={props}
        title='COMMON.STATUS'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'status',
    Cell: ({...props}) => (
      <PropertyRegistriesStatus PropertyRegistries={props.data[props.row.index]} />
    ),
  },

  // //HEADER COLUMN -  FIELDS ***
  // {
  //   Header: (props) => (
  //     <PropertyRegistriesCustomHeader
  //       tableProps={props}
  //       title='CONDITIONINGS.COST'
  //       className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
  //     />
  //   ),
  //   id: 'conditioning_cost',
  //   Cell: ({...props}) => <ConditioningsCost Conditionings={props.data[props.row.index]} />,
  // },

  //HEADER COLUMN - ACTIONS
  {
    Header: (props) => (
      <PropertyRegistriesCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <PropertyRegistriesActionsCell PropertyRegistries={props.data[props.row.index]} />
    ),
  },
]

export {PropertyRegistriesColumns}
